// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import React from "react";
// import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./helper/ScrollToTop";
import Layout from "./pages/Layout";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { lightTheme, darkTheme } from "./theme";
import useMediaQuery from "@mui/material/useMediaQuery";

import Home from "./pages/Home";
import Activities from "./pages/Activities";
import Team from "./pages/Team";
import Activity from "./pages/Activity";
import Equipment from "./pages/Equipment";
import History from "./pages/History";
import Law from "./pages/Law";
import NoPage from "./pages/NoPage";
// const Home = lazy(() => import("./pages/Home"));
// const Activities = lazy(() => import("./pages/Activities"));
// const Team = lazy(() => import("./pages/Team"));
// const Activity = lazy(() => import("./pages/Activity"));
// const Equipment = lazy(() => import("./pages/Equipment"));
// const Law = lazy(() => import("./pages/Law"));
// const NoPage = lazy(() => import("./pages/NoPage"));

export const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
});

function App() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [mode, setMode] = React.useState(
    prefersDarkMode === true ? "dark" : "light"
  );
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const theme = React.useMemo(
    () =>
      createTheme(
        mode === "light" ? createTheme(lightTheme) : createTheme(darkTheme)
      ),
    [mode]
  );

  console.log(`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASENAME}>
          <ScrollToTop />
          {/* <Suspense fallback={<h1>Loading...</h1>}> */}
          <Routes>
            <Route
              path="/"
              element={<Layout />}>
              <Route
                index
                element={<Home />}
              />
              <Route
                path="Aktivitaeten"
                element={<Activities />}
              />
              <Route
                path="Aktivitaeten/:activityId"
                element={<Activity />}
              />
              <Route
                path="Mannschaft"
                element={<Team />}
              />
              <Route
                path="Ausruestung"
                element={<Equipment />}
              />
              <Route
                path="Geschichte"
                element={<History />}
              />
              <Route
                path="Rechtliches"
                element={<Law />}
              />
              <Route
                path="*"
                element={<NoPage />}
              />
            </Route>
          </Routes>
          {/* </Suspense> */}
        </BrowserRouter>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
